import { createSlice } from "@reduxjs/toolkit";
import { fetchEventsBuilder } from "./builder";

const initialState = {
  events: {
    data: [],
  },
};

export const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchEventsBuilder(builder);
    builder.addCase("logout", () => initialState);
  },
});

export const selectEvents = (state) => state.events.events;
export default eventsSlice.reducer;
